<section class="initials">
  <a
    *ngFor="let initial of initialClass(); trackBy: trackByInitial"
    class="initials__item btn btn--link"
    [class.initials__item--active]="initial.active && initialActive === initial.initial"
    [class.btn--disabled]="!initial.active"
    [rel]="!initial.active ? 'nofollow' : ''"
    [tabindex]="!initial.active ? '-1' : null"
    [routerLink]="initial.link"
  >
    {{ initial.initial }}
  </a>
</section>
